import {
  Component,
  ElementRef,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ChangeDetectionStrategy,
  SimpleChanges
} from '@angular/core';
import { Picture } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SliderComponent implements OnChanges, AfterViewInit {
  @Input()
  pictures: Array<Picture> = [];
  @Input()
  indexSlide = 0;
  @Input()
  disableSwipe = false;
  @Output()
  onImageClick: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  onSlide: EventEmitter<number> = new EventEmitter<number>();

  // Elements
  public sliderElement: HTMLElement;
  public containerElement: HTMLElement;

  // Positions
  public touchStartX: number;
  public touchMoveX: number;
  public moveX: number;

  constructor(private elRef: ElementRef) {}

  /**
   * Get HTMLElement
   */
  ngAfterViewInit() {
    this.sliderElement = this.elRef.nativeElement.getElementsByClassName('slider')[0];
    this.containerElement = this.elRef.nativeElement.getElementsByClassName('slider__container')[0];
    this.moveToSlide(this.indexSlide);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.indexSlide && !changes.indexSlide.firstChange) {
      this.moveToSlide(this.indexSlide);
    }
  }

  /**
   * Get X position on touch start
   * @param event
   */
  onTouchStartEvent(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].pageX;
  }

  /**
   * Get X position on touch move, and move the container
   * @param event
   */
  onTouchMoveEvent(event: TouchEvent) {
    this.touchMoveX = event.changedTouches[0].pageX;
    this.moveX = this.indexSlide * this.sliderElement.clientWidth + (this.touchStartX - this.touchMoveX);

    if (this.moveX < this.sliderElement.clientWidth * this.pictures.length) {
      this.containerElement.style.transform = 'translate3d(-' + this.moveX + 'px,0,0)';
    }
  }

  /**
   * Choose to swipe left/right according to moveX
   * @param event
   */
  onTouchEndEvent(event: TouchEvent) {
    // Last position
    this.touchMoveX = event.changedTouches[0].pageX;
    this.moveX = this.indexSlide * this.sliderElement.clientWidth + (this.touchStartX - this.touchMoveX);

    const absMove = Math.abs(this.indexSlide * this.sliderElement.clientWidth - this.moveX);

    if (absMove > this.sliderElement.clientWidth / 4) {
      if (this.moveX > this.indexSlide * this.sliderElement.clientWidth && this.indexSlide < this.pictures.length - 1) {
        this.indexSlide++;
        this.onSlide.emit(this.indexSlide);
      } else if (this.moveX < this.indexSlide * this.sliderElement.clientWidth && this.indexSlide > 0) {
        this.indexSlide--;
        this.onSlide.emit(this.indexSlide);
      }
    }
    this.moveToSlide(this.indexSlide);
  }

  /**
   * Slide to index
   * @param index
   */
  moveToSlide(index: number) {
    this.containerElement.style.transform = 'translate3d(-' + index * this.sliderElement.clientWidth + 'px,0,0)';
  }
}
